import { createApp } from 'vue'
import SearchForm from '@/javascripts/search_form.vue'

const domain = document.getElementById('hp_key').getAttribute('domain')

const app = createApp({
  data() {
    return {
      domain: domain
    }
  },
  components: {
    'search_form': SearchForm
  },
})
app.mount('#SearchForm')
